import { render, staticRenderFns } from "./StepHospitalSelector.vue?vue&type=template&id=150bc6d9&"
import script from "./StepHospitalSelector.vue?vue&type=script&lang=js&"
export * from "./StepHospitalSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports